export default __webpack_public_path__ + "static/media/Treatment_DEEP_MOIST_200_U.d2fc7421.png";